/* export const watchlists = [
    {
        id: 'un-sanctions',
        name: 'UN Sanctions List',
        type: 'Entity',
        entries: [
            { name: 'Global Trading Co', nationality: 'SYR', dob: null },
            { name: 'John Smith', nationality: 'AFG', dob: '1975-01-10' },
            { name: 'Anna Petrova', nationality: 'RUS', dob: '1982-03-15' },
            { name: 'Al-Fahd Logistics', nationality: 'YEM', dob: null },
            { name: 'Kim Yong-Chol', nationality: 'PRK', dob: '1946-01-01' },
            { name: 'International Ventures LLC', nationality: 'IRN', dob: null },
        ]
    },
    {
        id: 'ofac-sdn',
        name: 'OFAC Specially Designated Nationals',
        type: 'Entity',
        entries: [
            { name: 'Sergei Ivanov', nationality: 'RUS', dob: '1965-05-20' },
            { name: 'Consolidated Materials Inc', nationality: 'IRN', dob: null },
            { name: 'Maria Garcia', nationality: 'CUB', dob: '1988-11-02' },
        ]
    },
    {
        id: 'suspicious-keywords',
        name: 'Suspicious Transaction Keywords',
        type: 'Keyword',
        entries: [ 
            'ammo', 'artillery', 'bearer bonds', 'layering', 
            'offshore shell', 'structuring', 'smurfing', 'hawala',
            'payment for invoice INV-000', // a common non-suspicious phrase
        ]
    },
    {
        id: 'pep-list',
        name: 'Politically Exposed Persons (PEP)',
        type: 'Entity',
        entries: [
            { name: 'Mikhail Mishustin', nationality: 'RUS', dob: '1966-03-03' },
            { name: 'Li Keqiang', nationality: 'CHN', dob: '1955-07-01' },
        ]
    }
]; */

export const watchlists = [
    { id: 'un-sanctions', name: 'UN Sanctions List', type: 'Entity', entries: [ { name: 'Global Trading Co', nationality: 'SYR' }, { name: 'Al-Fahd Logistics', nationality: 'YEM' }, { name: 'Kim Yong-Chol', nationality: 'PRK' }] },
    { id: 'ofac-sdn', name: 'OFAC SDN List', type: 'Entity', entries: [ { name: 'Consolidated Materials Inc', nationality: 'IRN' }, { name: 'Sergei Ivanov', nationality: 'RUS' }] },
    { id: 'suspicious-keywords', name: 'Suspicious Keywords', type: 'Keyword', entries: [ 'ammo', 'bearer bonds', 'layering', 'offshore shell', 'structuring', 'smurfing', 'hawala', 'commission for unspecified services' ]},
    { id: 'pep-list', name: 'Politically Exposed Persons', type: 'Entity', entries: [ { name: 'Abdullah bin Nasser', nationality: 'SAU' }, { name: 'Mikhail Mishustin', nationality: 'RUS' } ] }
];